import { createContext, useContext } from 'react';

export const LoadingContext = createContext<{
  isLoading: boolean;
  setIsLoading: any;
}>({
  isLoading: false,
  setIsLoading: () => {},
});

const useLoading = () => useContext(LoadingContext);
export default useLoading;
